var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCategoryHovering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 78,
    viewBox: "0 0 228 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_55_5292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 220,
    height: 70,
    rx: 8,
    fill: "#F3D479",
    fillOpacity: 0.15,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 219,
    height: 69,
    rx: 7.5,
    stroke: "#F2D272",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 48,
    height: 48,
    rx: 4,
    fill: "#F3D479",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_5292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 43.3334C42.6025 43.3334 46.3334 39.6025 46.3334 35.0001C46.3334 30.3977 42.6025 26.6667 38.0001 26.6667C33.3977 26.6667 29.6667 30.3977 29.6667 35.0001C29.6667 39.6025 33.3977 43.3334 38.0001 43.3334Z",
    stroke: "#F2D272",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 31.6667V38.3334",
    stroke: "#F2D272",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 35H41.3334",
    stroke: "#F2D272",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.8359 30.0742C80.8359 33.8066 79.8105 37.0059 75.2578 39.2754L74.4238 38.127C76.5635 37.0674 77.835 35.8369 78.5527 34.3672L74.7109 34.7363L74.5195 33.4238L79.0176 33.1367C79.1748 32.5625 79.2705 31.9541 79.3184 31.3047H75.1621V30.0742H80.8359ZM84.0898 28.8574V33.6973H85.9219V34.9414H84.0898V41.1895H82.5723V28.8574H84.0898ZM91.541 30.2793V31.4824H88.3691V33.6016H91.0215V34.7773H88.3691V37.1699C89.8389 37.1562 90.8506 37.0879 92.0605 36.8828L92.1973 38.0996C90.7754 38.373 89.5996 38.4004 87.7266 38.4004H86.9199V30.2793H91.541ZM97.1738 28.8574V41.2168H95.6973V28.8574H97.1738ZM94.5762 29.1035V40.6152H93.1543V34.6543H91.623V33.4238H93.1543V29.1035H94.5762ZM108.699 29.9922V31.1816C108.686 32.7129 108.686 34.4355 108.207 37.0195L106.676 36.8555C107.154 34.4492 107.154 32.6924 107.168 31.209H99.7852V29.9922H108.699ZM109.875 38.373V39.6172H98.6094V38.373H102.766V34.0801H104.27V38.373H109.875ZM121.004 28.8574V41.2305H119.5V28.8574H121.004ZM117.203 29.9375V34.5723H112.951V37.0605C114.899 37.0469 116.581 36.9512 118.502 36.623L118.639 37.8672C116.533 38.2363 114.688 38.3047 112.473 38.3047H111.393V33.3691H115.658V31.168H111.379V29.9375H117.203ZM137.396 36.2812V37.5254H132.502V41.2305H130.998V37.5254H126.131V36.2812H137.396ZM136.344 30.3203V31.5234H132.529C132.673 32.7471 134.279 34.0254 136.754 34.3262L136.193 35.5293C134.149 35.2695 132.563 34.3672 131.764 33.1777C130.95 34.3809 129.351 35.2695 127.293 35.5293L126.746 34.3262C129.214 34.0254 130.834 32.7676 130.984 31.5234H127.17V30.3203H130.998V28.8711H132.502V30.3203H136.344ZM147.91 28.8574V33.6836H149.742V34.9551H147.91V41.1895H146.393V28.8574H147.91ZM144.643 30.1426C144.643 33.7793 143.139 36.9648 139.023 38.9883L138.162 37.8125C141.17 36.3154 142.797 34.21 143.111 31.4004H138.832V30.1426H144.643ZM160.01 28.8574V33.7793H161.91V35.0371H160.01V41.2168H158.506V28.8574H160.01ZM157.549 30.7578V31.9746H150.262V30.7578H153.188V29.0352H154.705V30.7578H157.549ZM153.953 32.7812C155.73 32.7812 157.057 33.9844 157.057 35.6934C157.057 37.4023 155.73 38.5918 153.953 38.5918C152.148 38.5918 150.822 37.4023 150.836 35.6934C150.822 33.9844 152.148 32.7812 153.953 32.7812ZM153.953 34.0254C152.982 34.0254 152.285 34.6816 152.285 35.6934C152.285 36.7051 152.982 37.3477 153.953 37.334C154.896 37.3477 155.594 36.7051 155.607 35.6934C155.594 34.6816 154.896 34.0254 153.953 34.0254ZM172.752 28.8574V41.2168H171.221V28.8574H172.752ZM169.061 30.1699C169.061 33.8477 167.639 36.9785 163.305 39.0293L162.512 37.8125C165.745 36.2744 167.249 34.1826 167.516 31.373H163.141V30.1699H169.061Z",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_55_5292",
    x: 0,
    y: 0,
    width: 228,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.823529 0 0 0 0 0.447059 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_5292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_5292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_5292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(28 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCategoryHovering);
export default __webpack_public_path__ + "static/media/add_category_hovering.7b6d4204d6a713d66e51d1c2cd19d8d2.svg";
export { ForwardRef as ReactComponent };